import { NameDto } from '../Common/Types'
import { CurrencyType } from '../Wallet/Types/Wallet'

export interface InterestRateDto {
  client: {
    id: string
    name: string
  }
  wallet: {
    id: string
    name: string
  }
  amount: number
  totalWalletBalance: number
  balanceDate: Date
  maxInterestRate: number
  givenInterestRate: number
  createdDate: Date
}

export interface InterestRateConfigDto {
  id: string
  tickmillCompany: NameDto
  country: NameDto<string>
  currency: NameDto<CurrencyType>
  walletType: NameDto
  enabled: boolean
}

export interface InterestRateThresholdDto {
  id: string
  currency: NameDto<CurrencyType>
  maxAmount: number
  minInterestRate: number
  maxInterestRate: number
}

export interface InterestRateThresholdCreateDto {
  id: string
  currencyId: string
  maxAmount: number
  minInterestRate: number
  maxInterestRate: number
}

export interface InterestRateEligibilityCriteriaDto {
  id: string
  value: string
  eligibilityCriteriaType: NameDto
}

export interface InterestRateEligibilityCriteriaTypeDto {
  id: number
  name: string
}

export interface InterestRateEligibilityCriteriaCreateDto {
  id: string
  interestRateEligibilityCriteriaTypeId: number
  value: string
}

export enum InterestRateKey {
  id = 'client.id',
  name = 'client.name',
  walletId = 'wallet.id',
  walletName = 'wallet.name',
  walletType = 'walletType.name',
  tickmillCompanyName = 'tickmillCompany.name',
  EligibilityCriteriaType = 'eligibilityCriteriaType.name',
  country = 'country.name',
  amount = 'amount',
  currency = 'currency.name',
  totalWalletBalance = 'totalWalletBalance',
  balanceDate = 'balanceDate',
  maxInterestRate = 'maxInterestRate',
  givenInterestRate = 'givenInterestRate',
  createdDate = 'createdDate',
  enabled = 'enabled',
}

export enum InterestRateFilterKey {
  ID = 'Id',
  NAME = 'Name',
  WALLET_ID = 'WalletId',
  WALLET_NAME = 'WalletName',
  WALLET_TYPE_ID = 'WalletTypeId',
  TICKMILL_COMPANY_ID = 'TickmillCompanyId',
  AMOUNT = 'Amount',
  COUNTRY = 'CountryId',
  CURRENCY = 'CurrencyId',
  ELIGIBILITY_CRITERIA_TYPE = 'EligibilityCriteriaTypeId',
  TOTAL_WALLET_BALANCE = 'TotalWalletBalance',
  BALANCE_DATE = 'BalanceDate',
  MAX_INTEREST_RATE = 'MaxInterestRate',
  GIVEN_INTEREST_RATE = 'GivenInterestRate',
  CREATED_DATE = 'DateFrom',
  ENABLED = 'Enabled',
}

export enum InterestRateSortKey {
  ID = 'Id',
  NAME = 'Name',
  WALLET_ID = 'WalletId',
  WALLET_NAME = 'WalletName',
  AMOUNT = 'Amount',
  TOTAL_WALLET_BALANCE = 'TotalWalletBalance',
  BALANCE_DATE = 'BalanceDate',
  MAX_INTEREST_RATE = 'MaxInterestRate',
  GIVEN_INTEREST_RATE = 'GivenInterestRate',
  CREATED_DATE = 'DateFrom',
}
